import { usePlayground } from '../store'
import type { TabMode } from '../store'

const tabs: { id: TabMode; label: string; icon: JSX.Element }[] = [
    {
        id: 'source',
        label: 'Source',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
            </svg>
        ),
    },
    {
        id: 'graph',
        label: 'Diagram',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="5" r="3" /><circle cx="5" cy="19" r="3" /><circle cx="19" cy="19" r="3" />
                <line x1="12" y1="8" x2="5" y2="16" /><line x1="12" y1="8" x2="19" y2="16" />
            </svg>
        ),
    },
    {
        id: 'narrative',
        label: 'Structure',
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 11h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1H9.01V5a2 2 0 0 0-2-2H4c-1.1 0-2 .9-2 2v4a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V8h2v7.01c0 1.65 1.34 2.99 2.99 2.99H15v1a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1h-1.01c-.54 0-.99-.45-.99-.99V8h2v1c0 1.1.9 2 2 2z" />
            </svg>
        ),
    },
]

export function MobileNav() {
    const activeTab = usePlayground((s) => s.activeTab)
    const setActiveTab = usePlayground((s) => s.setActiveTab)

    return (
        <nav
            className="fixed bottom-0 left-0 right-0 border-t flex items-stretch z-50"
            style={{
                height: '48px',
                paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                background: 'color-mix(in srgb, var(--bg) 95%, transparent)',
                backdropFilter: 'blur(16px)',
                borderColor: 'var(--border-subtle)',
            }}
        >
            {tabs.map(tab => {
                const active = activeTab === tab.id
                return (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className="flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors active:scale-[0.97]"
                        style={{
                            color: active ? 'var(--accent)' : 'var(--text-muted)',
                            position: 'relative',
                        }}
                    >
                        {/* Active accent bar */}
                        {active && (
                            <div
                                className="absolute top-0 left-1/4 right-1/4 h-0.5 rounded-full"
                                style={{ background: 'var(--accent)' }}
                            />
                        )}
                        {tab.icon}
                        <span className="text-xs font-bold font-mono uppercase tracking-wider">
                            {tab.label}
                        </span>
                    </button>
                )
            })}
        </nav>
    )
}
